export enum Usage {
  HERB = "herb",
  SMALL_FRUIT = "small_fruit",
  FRUIT = "fruit",
  VEGETABLE = "vegetable",
  FLOWER = "flower",
  GREEN_MANURE = "green_manure",
  CEREAL = "cereal",
  OILSEED = "oilseed",
  TEXTILE = "textile",
  SPICE = "spice",
  MELLIFEROUS = "melliferous",
  MEDICIAL = "medicinal",
  OTHER = "other",
}

export interface UsageOption {
  value: Usage;
  display: string;
}
